<template>
  <div class='step3'>
    <a-card size='small' hoverable>
      <div class='header'><b>元素数据源</b><a-button @click='addDataSource("element")' type="primary" size='small' style='float: right'>添加</a-button></div>
      <a-divider style='margin: 12px 0'/>
      <div class='list'>
        <div class='list-item' v-for='(item,index) in model.itemList'>
          <a-space :size='12'>
            <span style="width: 80px;display: inline-block;text-align: right">数据源{{index + 1}}：</span>
            <a-select v-model='item.formId' placeholder='请选择表单' style='width: 200px' showSearch :filterOption="filterOptionTip"  @change="formIdChange(item)" :disabled="index===0">
              <a-select-option  :value='form.id' :key="form.id" v-for="form in formList">
                <a-tooltip :title="form.description">
                  {{ form.name }}
                </a-tooltip>
              </a-select-option>
            </a-select>
            <a-select v-model='item.formItemId' placeholder='请选择元素' style='width: 500px' showSearch :filterOption="filterOption" @change="formItemChange(item)" :disabled="index===0">
              <a-select-option :value='formItem.id' :key="formItem.id" v-for="formItem in item.formItemList">{{formItem.number || ""}}{{formItem.name}}</a-select-option>
            </a-select>
            <span><a-icon v-if='index > 0' type="close" @click='removeDataSource("element", index)'/></span>
            <!-- <span v-if="item.isCheckValue">多选题：              
              <a-radio-group v-model="item.checkValueType">
                <a-radio value="1">选项值求和</a-radio>
                <a-radio value="2">保留原值</a-radio>
              </a-radio-group>
            </span> -->
          </a-space>
        </div>
      </div>
    </a-card>
    <a-card size='small' hoverable>
          <div class='header'><b>基本信息数据源</b><a-button @click='addDataSource("baseInfo")' type="primary" size='small' style='float: right'>添加</a-button></div>
          <a-divider style='margin: 12px 0'/>
          <div class='list' v-if="model.itemList2">
            <div class='list-item' v-for='(item,index) in model.itemList2'>
              <a-space :size='12'>
                <span>数据源{{ index + 1}}</span>
                <a-select v-model='item.formItemId' placeholder='请选择基础信息' style='width: 300px' showSearch @change="source2Change(item)" :filterOption="filterOption">
                  <a-select-option :value='field.id' v-for="field in patientFieldList" :key="field.id">{{field.name}}</a-select-option>
                </a-select>
                <span><a-icon type="close" @click='removeDataSource("baseInfo", index)'/></span>
              </a-space>
            </div>
          </div>
        </a-card>
    <a-card size='small' hoverable>
          <div class='header'><b>周期数据源</b><a-button @click='addDataSource("period")' type="primary" size='small' style='float: right'>添加</a-button></div>
          <a-divider style='margin: 12px 0'/>
          <div class='list' v-if="model.itemList4">
            <div class='list-item' v-for='(item,index) in model.itemList4'>
              <a-space :size='12'>
                <span>数据源{{index + 1}}</span>
                <!-- <a-select v-model='item.formId' placeholder='请选择周期' style='width: 300px' showSearch :filterOption="filterOption">
                  <a-select-option :value='period.id' v-for="period in periodList" :key="period.id">{{period.name}}</a-select-option>
                </a-select> -->
                <a-select v-model='item.formItemId' placeholder='请选择元素' style='width: 600px' showSearch @change="source4ItemChange(item)" :filterOption="filterOption">
                  <a-select-option :value='periodItem.value' v-for="periodItem in periodItemList" :key="periodItem.value">{{periodItem.label}}</a-select-option>
                </a-select>
                <span><a-icon type="close" @click='removeDataSource("period", index)'/></span>
              </a-space>
            </div>
          </div>
        </a-card>
  </div>
</template>

<script>
import { getAction } from '@/api/manage'
export default {
  name: 'Step2',
  components: {  },
  data() {
    return {
      model:{},
      formList:[],
      patientFieldList:[],
      periodItemList:[{ label: '周期开始时间', value: 'startDate' },{ label: '周期结束时间', value: 'endDate' }, { label: '周期完成时间', value: 'submitDate' },{ label: '周期分组名称', value: 'groupName' }],
    }
  },
  created() {

  },
  methods: {
    view(model){
      this.model = JSON.parse(JSON.stringify(model))
      console.log("this.model:"+this.model)
      if(!this.model.itemList || this.model.itemList.length===0){
        this.$set(this.model,'itemList',this.model.itemList || [])
        this.model.itemList.push({
          formItemId:model.formItemId,
          periodRule:'1',
          formId:model.formId,
          sourceType: '1',
        })
      }else{
        const itemList1 = []
            const itemList2 = []
            const itemList3 = []
            const itemList4 = []
            this.model.itemList.forEach(item=>{
              if(item.sourceType==='1'){
                itemList1.push(item);                
              }
              if(item.sourceType==='3'){
                itemList2.push(item);
                this.source2Change(item)
              }
              if(item.sourceType==='2'){
                itemList3.push(item);
              }
              if(item.sourceType==='5'){//周期数据源
                itemList4.push(item);
                this.source4ItemChange(item)
              }
            })
            this.$set(this.model,'itemList',itemList1)
            this.$set(this.model,'itemList2',itemList2)
            this.$set(this.model,'itemList3',itemList3)
            this.$set(this.model,'itemList4',itemList4)
      }      

      this.$nextTick(()=>{
        this.model.itemList.forEach(item=>{
          if(item.formId){
            getAction('/project/projectFormItem/listAll',{formId:item.formId}).then(res=>{
              if(res.success){
                // item.formItemList = res.result
                this.$set(item,'formItemList',res.result)
                // console.log("item.checkValueType:"+item.checkValueType)
                this.formItemChange(item)
              }
            })
          }
        })

      })
      getAction('/project/projectForm/listAll',{projectId:this.model.projectId}).then(res=>{
        if(res.success){
          this.formList=res.result
        }
      })
      getAction('/project/projectPatientField/editList',{projectId:this.model.projectId}).then(res=>{
        if(res.success){
          this.patientFieldList=res.result
        }
      })

    },
    formIdChange(item){
      this.$set(item,'formItemList',[])
      if(item.formItemId){
        item.formItemId = null
      }
      if(item.formId){
        getAction('/project/projectFormItem/listAll',{formId:item.formId}).then(res=>{
          if(res.success){
            // item.formItemList = res.result
            this.$set(item,'formItemList',res.result)
          }
        })
      }
    },
    formItemChange(item){
      // console.log("formItemChange")
        let items = item.formItemList.filter(i=>i.id == item.formItemId)
        if(items && items.length > 0){
          if(items[0].elementType=='check'){
            this.$set(item,'isCheckValue',true)
            if(!item.checkValueType){
              this.$set(item,'checkValueType',"1")
            }else{
              this.$set(item,'checkValueType',item.checkValueType+'')
            }
          }else{
            this.$set(item,'isCheckValue',false)
          }
        }        
    },
    source2Change(item){
      const field = this.patientFieldList.filter(field=>field.id===item.formItemId)[0]
      if(field){
        item.name=`[${field.name}]`
      }
    },
    source4ItemChange(item){
      const field = this.periodItemList.filter(field=>field.value===item.formItemId)[0]
      if(field){
        item.name=`【${field.label}】`
      }
    },
    /**
     * 添加数据源
     */
    addDataSource(key) {
      // this.model.itemList.push({})
      switch (key) {
        case 'element':
          const dataSource1 = this.model.itemList || []          
          dataSource1.push({sourceType: '1'})
          this.$set(this.model,'itemList',dataSource1)
          break
        case 'baseInfo':
          const dataSource2 = this.model.itemList2 || []
          dataSource2.push({sourceType: '3'})
          this.$set(this.model,'itemList2',dataSource2)
          break
        case 'scale':
          const dataSource3 = this.model.itemList3 || []
          dataSource3.push({sourceType: '2'})
          this.$set(this.model,'itemList3',dataSource3)
          break
        case 'period':
          const dataSource4 = this.model.itemList4 || []
          dataSource4.push({sourceType: '5'})
          this.$set(this.model,'itemList4',dataSource4)
          break
      }
    },
    /**
     * 移除数据源
     * @param index
     */
    removeDataSource(key,index) {
      // this.model.itemList.splice(index, 1)
      switch (key) {
        case 'element':
          this.model.itemList.splice(index, 1)
          break
        case 'baseInfo':
          this.model.itemList2.splice(index, 1)
          break
        case 'scale':
          this.model.itemList3.splice(index, 1)
          break
        case 'period':
          this.model.itemList4.splice(index, 1)
          break
      }
    },

    validate() {
      /*简陋验证逻辑,请修改*/
      // if(!this.model.itemList || this.model.itemList.length===0){
      //   this.$message.warning("请添加元素数据源")
      //   return false
      // }
      if( !(
        (this.model.itemList && this.model.itemList.length>0)
        ||(this.model.itemList2 && this.model.itemList2.length>0)
        ||(this.model.itemList3 && this.model.itemList3.length>0)
        ||(this.model.itemList4 && this.model.itemList4.length>0)
      )){        
        this.$message.warning('数据源不能为空')
        return false
      }

      let error = false
      this.model.itemList.forEach((item,index) =>{
        if(error){
          return
        }
        if(!item.formId || !item.formItemId){
          this.$message.warning(`数据源${index+1}请填写完整`)
          error = true
        }
      })
      if(error){
        return false
      }
      // if(this.model.type!=3){
      // const itemIdList = []
      // this.model.itemList.forEach((item,index)=>{
      //   if(error){
      //     return
      //   }
      //   if(itemIdList.indexOf(item.formItemId)>=0){
      //     error = true
      //     this.$message.warning(`数据源${index+1}重复添加`)
      //   }else{
      //     itemIdList.push(item.formItemId)
      //   }
      // })
      // }
      if(this.model.itemList2){
        const nameList = []
        this.model.itemList2.forEach((item,index)=>{
          if(!item.formItemId){
            error = true         
            this.$message.warning(`基本信息数据源${index+1}请填写完整`)
            return
          }
          if(nameList.indexOf(item.name)>=0){
            error = true  
            this.$message.warning(`基本信息数据源${index+1}重复添加`)
            return
          }else{
            nameList.push(item.name)
          }
        })
        if(error){
          return false
        }
      }
      
      if(this.model.itemList4){
        const nameList = []
        this.model.itemList4.forEach((item,index)=>{          
          if(!item.name){    
            error = true  
            this.$message.warning(`周期数据源${index+1}请填写完整`)
            return
          }
          if(nameList.indexOf(item.name)>=0){    
            error = true        
            this.$message.warning(`周期数据源${index+1}重复添加`)
            return
          }else{
            nameList.push(item.name)
          }
        })
        if(error){
          return false
        }
      }
      this.model.itemList.forEach((item) =>{
        const formName=this.formList.filter(form=> form.id===item.formId)[0].name
        let formItem = item.formItemList.filter(formItem=> formItem.id===item.formItemId)[0]
        item.name=`【${formName}.${formItem.number}.${formItem.name}】`
      })
      return true
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    filterOptionTip(input, option) {
      return option.componentOptions.children[0].componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
  }
}
</script>

<style scoped>
.step3 {
  padding: 0 80px;
}
.header {
  font-size: 16px;
}
.list{
  text-align: center;
}
.list > .list-item {
  margin: 12px auto;
  text-align: left;
  width: 1200px;
}
</style>
